import WalletNotAvailable from './WalletNotAvailable';

export default WalletNotAvailable;
